import AddFillableFieldsModalEnum from '../AddFillableFieldsModalConstants';

export const DEFAULT_STATE = false;

const isAddFillableFieldsModalOpen = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case AddFillableFieldsModalEnum.ADD_FILLABLE_FIELDS_MODAL_OPEN:
      return true;
    case AddFillableFieldsModalEnum.ADD_FILLABLE_FIELDS_MODAL_CLOSE:
      return false;
    default:
      return state;
  }
};

export default isAddFillableFieldsModalOpen;



// WEBPACK FOOTER //
// ./src-react/Modals/AddFillableFieldsModal/AddFillableFieldsModalReducer/isAddFillableFieldsModalOpen.jsx